// TODO: setup dark colors.

const darkTheme = {
  mode: 'dark',
  colors: {
    white: '#FFFFFF',
    lightestGray: '#f6f9fc',
    lightGrey: '#DADADA',
    textGrey: '#8C8C8C',
    grey: '#4F4F4F',
    midGrey: '#2F2F2F',
    darkGrey: '#1E2022',
    linearGradient: '#1D1D1D',
    lightBlue: '#0693C9',
    midBlue: '#0485BA',
    darkBlue: '#001F4B',
    green: '#45BE41',
    orange: '#F39902',
    red: '#DB3A2A',
    text: {
      primary: '#001F4B',
      secondary: '#8C8C8C',
    },
    outline: {
      primary: '#DADADA',
    },
  },
  typography: {
    primary: {
      regular: 'NLRTM',
      bold: 'NLRTM-Bold',
    },
  },
};
export default darkTheme;
